import { render, staticRenderFns } from "./ExportDownloadLink.vue?vue&type=template&id=10d88bc4"
import script from "./ExportDownloadLink.vue?vue&type=script&lang=js"
export * from "./ExportDownloadLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports